import Typography from "@mui/material/Typography";
import { Button } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export default function NavButton(props) {
	return (
		<Button
			sx={{
				justifyContent: "left",
				"&:hover": {
					cursor: "pointer",
					backgroundColor: "#F5F5F5",
					"& .button-text": {
						textDecoration: "underline",
					},
				},
			}}
			color="inherit"
			disabled={props.disabled}
			component={RouterLink}
			to={props.link}
			onClick={
				() => {
					if (props.link === window.location.pathname) {
						window.location.reload();
					}
				} /* Reload page if already on the page */
			}
		>
			<Typography
				className="button-text"
				color={props.disabled ? "#cfcfd1" : "black"}
				fontWeight={400}
			>
				{props.navTo}
			</Typography>
		</Button>
	);
}
